import type { BottomTabBarProps } from '@react-navigation/bottom-tabs';
import { TabButton } from 'smoothie';

interface SideNavBarItemProps extends Omit<BottomTabBarProps, 'insets'> {
    index: number;
    routeKey: string;
    routeName: string;
    routeParams: Record<string, unknown>;
    label: string;
}

export const SideNavBarItem = ({
    state,
    descriptors,
    navigation,
    index,
    routeKey,
    routeName,
    routeParams,
    label,
}: SideNavBarItemProps) => {
    const isSelected = state.index === index;

    const screenOptions = descriptors[routeKey]?.options;
    const tabIconFunction = screenOptions?.tabBarIcon;
    const activeColor = screenOptions?.tabBarActiveTintColor;
    const inactiveColor = screenOptions?.tabBarInactiveTintColor;
    const tabIcon = tabIconFunction?.({
        focused: isSelected,
        color: (isSelected ? activeColor : inactiveColor) ?? 'black',
        size: 23,
    });

    const onPress = () => {
        const event = navigation.emit({
            type: 'tabPress',
            target: routeKey,
            canPreventDefault: true,
        });

        if (!isSelected && !event.defaultPrevented) {
            navigation.navigate(routeName, routeParams);
        }
    };

    return (
        <TabButton
            key={routeKey}
            icon={tabIcon}
            text={label}
            isSelected={isSelected}
            onPress={onPress}
        />
    );
};
